export const GRID_WIDTH_TIMESERIES = 2;
export const GRID_WIDTH_TAG = 1;
export const MAX_GRID_COLS_DASHBOARD = 3;
export const MAX_GRID_COLS_REPORT = 1;
export const DEFAULT_GRID_HEIGHT = 1;
export const DEFAULT_GRID_WIDTH_REPORT = 1;
export const MAX_ROW_HEIGHT_DASHBOARD = 240;
export const MAX_ROW_HEIGHT_REPORT = 260;

const GRID_CONSTANTS = {
  GRID_WIDTH_TIMESERIES,
  GRID_WIDTH_TAG,
  MAX_GRID_COLS_DASHBOARD,
  MAX_GRID_COLS_REPORT,
  DEFAULT_GRID_HEIGHT,
  DEFAULT_GRID_WIDTH_REPORT,
  MAX_ROW_HEIGHT_DASHBOARD,
  MAX_ROW_HEIGHT_REPORT
};
export default GRID_CONSTANTS;
